import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Construction as ConstructionIcon, Clock, Sparkles, ArrowLeft } from "lucide-react";
import fondImageDesktop from "../../components/profileUser/assets/Fond-Large.jpg";
import fondImageMobile from "../../components/profileUser/assets/Fond.jpg";
import { motion } from 'framer-motion';

const Construction = () => {
    const { t } = useTranslation(['common']);
    const navigate = useNavigate();

    const features = [
        { emoji: "🚀", title: t('common:construction.features.soon.title'), desc: t('common:construction.features.soon.desc') },
        { emoji: "✨", title: t('common:construction.features.new.title'), desc: t('common:construction.features.new.desc') },
        { emoji: "🔒", title: t('common:construction.features.secure.title'), desc: t('common:construction.features.secure.desc') },
        { emoji: "📱", title: t('common:construction.features.mobile.title'), desc: t('common:construction.features.mobile.desc') },
    ];

    return (
        <div className="min-h-screen relative">
            {/* Background Images */}
            <div
                className="fixed inset-0 w-full h-full bg-cover bg-center bg-no-repeat -z-10 md:hidden"
                style={{ backgroundImage: `url(${fondImageMobile})` }}
            />
            <div
                className="fixed inset-0 w-full h-full bg-cover bg-center bg-no-repeat -z-10 hidden md:block"
                style={{ backgroundImage: `url(${fondImageDesktop})` }}
            />

            <div className="px-6 md:px-16 lg:px-32 py-8">
                <div className="max-w-2xl mx-auto">
                    {/* Header Card */}
                    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 p-8 mb-8 shadow-2xl animate-fade-in">
                        {/* Decorative elements */}
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
                        <div className="absolute bottom-0 left-0 w-32 h-32 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2" />

                        <div className="relative z-10 flex flex-col items-center text-center">
                            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-6">
                                <ConstructionIcon className="w-10 h-10 text-white" />
                            </div>

                            <div className="flex items-center gap-2 bg-amber-400/20 text-amber-300 px-4 py-1.5 rounded-full text-xs font-bold mb-4">
                                <Clock className="w-4 h-4" />
                                {t('common:construction.badge')}
                            </div>

                            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
                                {t('common:construction.title')}
                            </h1>
                            <p className="text-blue-100 text-sm md:text-base max-w-md">
                                {t('common:construction.message')}
                            </p>
                        </div>
                    </div>

                    {/* Features Preview */}
                    <div className="grid grid-cols-2 gap-4 mb-8">
                        {features.map((feature, idx) => (
                            <div
                                key={idx}
                                className="bg-white/80 backdrop-blur-sm rounded-2xl p-4 border border-gray-100 hover:shadow-lg transition-shadow"
                            >
                                <span className="text-2xl mb-2 block">{feature.emoji}</span>
                                <h3 className="font-bold text-gray-900 text-sm mb-1">{feature.title}</h3>
                                <p className="text-xs text-gray-500">{feature.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* Back Button */}
                    <button
                        onClick={() => navigate('/home')}
                        className="w-full bg-white/90 backdrop-blur-sm text-blue-600 py-4 rounded-xl font-bold text-sm flex items-center justify-center gap-2 shadow-lg shadow-blue-500/10 hover:bg-white transition-all border border-blue-100"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        {t('common:construction.back')}
                    </button>

                    {/* Bottom spacer for mobile nav */}
                    <div className="h-24 md:hidden" />
                </div>
            </div>
        </div>
    );
};

export default Construction;
